import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { PageHeader } from "@/widgets/page-header"
import { useNavigate, useParams } from "react-router-dom"
import { fetchUser, selectUser, setRouteUserId } from "../model"
import { useEffect } from "react"
import { TabControl } from "./tab-control"
import { ErrorType } from "@/shared/types"

export const UserProfilePage = () => {
    const { id } = useParams()
    const user = useAppSelector(selectUser)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        let active = true
        dispatch(setRouteUserId(id ?? null))
        if (id !== user.id) {
            dispatch(fetchUser(id))
            .unwrap()
            .catch((err: ErrorType) => {
                // The route may have changed or the page unmounted while the
                // request was in flight: a rejected GET for a profile we
                // already left must not redirect.
                if (!active) return
                if (err.error_id === 'user_doesnt_exists') {
                    navigate('/404', { replace: true })
                }
            })
        }
        return () => { active = false }
    }, [id])

    return (
        <div className="_page_container">
            <PageHeader title="профиль" />
            <TabControl />
        </div>
    )
}